import { render, staticRenderFns } from "./ModifySalePeriod.vue?vue&type=template&id=28864c08&"
import script from "./ModifySalePeriod.vue?vue&type=script&lang=ts&"
export * from "./ModifySalePeriod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports